
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPistonClosedRight as ObiTwowayAcuatorPistonClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-closed-right.js';
 
 
 

 
 export const ObiTwowayAcuatorPistonClosedRight = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-closed-right',
   elementClass: ObiTwowayAcuatorPistonClosedRightElement,
   events: {
     
   }
  });
 
 